import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { message } from "antd";
import { useAxios } from "../useAxios";
import { LevelBCandidateDetail } from "../../types/levelb-reports";

export interface UseGetLevelBCandidateDetailOptions {
  examInstanceId: string | null;
  enabled?: boolean;
}

export function useGetLevelBCandidateDetail({
  examInstanceId,
  enabled = true,
}: UseGetLevelBCandidateDetailOptions) {
  const { t } = useTranslation();
  const axios = useAxios();

  return useQuery<LevelBCandidateDetail | null>({
    queryKey: ["levelDCandidateDetail", examInstanceId],
    queryFn: async () => {
      if (!examInstanceId) {
        return null;
      }

      try {
        const response = await axios.get<LevelBCandidateDetail>(
          `api/levelbreports/candidates/${examInstanceId}`
        );
        return response.data;
      } catch (error: unknown) {
        if ((error as { response?: { status: number } })?.response?.status === 404) {
          return null;
        }
        message.error(t("levelBReports.errors.getCandidateDetail"));
        throw error;
      }
    },
    enabled: enabled && !!examInstanceId,
    staleTime: 30 * 1000, // 30 seconds
    retry: 1,
  });
}

